module.exports = new __parcel__URL__("small-health-potion.bffb3fcc.webp").toString();